import { render, staticRenderFns } from "./SegmenPerusahaan.vue?vue&type=template&id=2ab725df&scoped=true"
import script from "./SegmenPerusahaan.vue?vue&type=script&lang=js"
export * from "./SegmenPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./SegmenPerusahaan.vue?vue&type=style&index=0&id=2ab725df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab725df",
  null
  
)

export default component.exports